/* eslint-disable camelcase */
// Mirrors backend ai_components/feedback/serializers.py and MAI feedback/serializers.py.
// Keep in sync via OpenAPI codegen ideally; until then, hand-maintained.

export const MessageType = {
  PREVIEW: 'preview',
  SHOPPER_RESPONSE: 'shopper_response',
  SHOPPER_AUTOMATION: 'shopper_automation',
  INFINITY_TESTING: 'infinity_testing',
  INFINITY_TESTING_CAMPAIGN: 'infinity_testing_campaign',
  INFINITY_TESTING_AUTOMATION: 'infinity_testing_automation',
  PLAYGROUND: 'playground',
  OUTREACH_MESSAGE: 'outreach_message',
  BRAND_CENTER_IT_PREVIEW: 'brand_center_it_preview',
  ASK_SHOPPER_REPORT: 'ask_shopper_report',
} as const;
export type MessageType = typeof MessageType[keyof typeof MessageType];

export const FeedbackSource = {
  PREVIEW_UI: 'preview_ui',
  CONVERSATIONS_VIEW: 'conversations_view',
  PLAYGROUND: 'playground',
  INFINITY_TESTING_UI: 'infinity_testing_ui',
  FLOW_BUILDER: 'flow_builder',
  BRAND_CENTER: 'brand_center',
  ASK_SHOPPER_UI: 'ask_shopper_ui',
} as const;
export type FeedbackSource = typeof FeedbackSource[keyof typeof FeedbackSource];

export const FeedbackType = {
  THUMBS_UP: 'thumbs_up',
  THUMBS_DOWN: 'thumbs_down',
  NONE: 'none',
} as const;
export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];

export interface FeedbackMetadata {
  selectedPills?: string[];
  [key: string]: unknown;
}

export interface UnifiedFeedbackPayload {
  messageType: MessageType;
  feedbackSource: FeedbackSource;
  feedbackType: FeedbackType;
  messageGuid?: string;
  messageId?: number;
  subscriberId?: number;
  messageText?: string;
  feedbackValue?: string;
  feedbackMetadata?: FeedbackMetadata;
  typeId?: number;
  // Targets another shop's message (admin/sales agents viewing a shop's
  // conversation). Sent as a query param, never in the request body.
  shopId?: number;
}

export interface FeedbackResponseItem {
  guid: string;
  messageId?: number;
  messageGuid?: string;
  messageType: MessageType;
  feedbackSource: FeedbackSource;
  feedbackType: FeedbackType;
  feedbackValue?: string;
  feedbackMetadata?: FeedbackMetadata;
  shopId?: number;
  subscriberId?: number;
  conversationId?: string;
  messageText?: string;
  createdAt: string;
}

export interface FeedbackMap {
  byMessageId: Record<number, FeedbackResponseItem>;
  byMessageGuid: Record<string, FeedbackResponseItem>;
}
